import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { StepForm } from '@grandvisionhq/configurator';
import { useIntl } from '@grandvisionhq/state';
import { Upload } from '@grandvisionhq/upload';
import { PD_SCOPE, RX_SCOPE, PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID } from '../../../../../state/constants.js';

var PrescriptionUploadForm = (_param)=>{
    var { className , onSubmit , onStatusChange , uploadState  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "onSubmit",
        "onStatusChange",
        "uploadState"
    ]);
    const { getLabel  } = useIntl();
    const uploadLayout = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT) ? 'vertical' : 'horizontal';
    const handlePDStatusChange = React__default.useCallback((status)=>onStatusChange(status, PD_SCOPE)
    , [
        onStatusChange
    ]);
    const handleRXStatusChange = React__default.useCallback((status)=>onStatusChange(status, RX_SCOPE)
    , [
        onStatusChange
    ]);
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(StepForm, {
        className: classnames('prescription-upload-form', className),
        "data-t": rest['data-t'],
        onSubmit: onSubmit
    }, /*#__PURE__*/ React__default.createElement(Upload, {
        variant: uploadLayout,
        id: "rx-upload",
        iconName: "upload-prescription",
        title: getLabel('products.glasses.upload.rx.title'),
        "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID,
        onStatusChange: handleRXStatusChange,
        uploadStatus: uploadState[RX_SCOPE],
        referenceId: RX_SCOPE,
        scope: RX_SCOPE,
        className: "prescription-upload-form__uploader"
    }), /*#__PURE__*/ React__default.createElement(Upload, {
        variant: uploadLayout,
        id: "pd-upload",
        iconName: "upload-pd",
        title: getLabel('products.glasses.upload.pd.title'),
        "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID,
        onStatusChange: handlePDStatusChange,
        uploadStatus: uploadState[PD_SCOPE],
        referenceId: PD_SCOPE,
        scope: PD_SCOPE,
        className: "prescription-upload-form__uploader"
    })));
};

export { PrescriptionUploadForm };
//# sourceMappingURL=PrescriptionUploadForm.js.map
